module.exports = __webpack_public_path__ + "img/dpsy-icon-fw.029c81ca.png";